import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhCampaignTransactions extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhCampaignTransactions'
  // Define default properties here
  static instanceDefaults() {
    return {
      campaign_id: null,
      allocation_id: null,
      user_id: null,
      transaction_type: 'RESERVE',
      tokens_amount: 0,
      music_id: null,
      survey_id: null,
      date_created: null,
      metadata: null
    }
  }
}
const servicePath = 'bh-campaign-transactions';
const servicePlugin = makeServicePlugin({
  Model: BhCampaignTransactions,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
